// Selectors
export const selectWaitlistLoading = (state) => state.waitlist.loading;
export const selectWaitlistError = (state) => state.waitlist.error;
export const selectIsSubmitted = (state) => state.waitlist.isSubmitted;
export const selectSubmittedEntry = (state) => state.waitlist.submittedEntry;
export const selectWaitlistCount = (state) => state.waitlist.waitlistCount;
export const selectWaitlistStats = (state) => state.waitlist.stats;
export const selectIsUserApproved = (state) => state.waitlist.isUserApproved;
export const selectCheckingApproval = (state) => state.waitlist.checkingApproval;
export const selectEmailExists = (state) => state.waitlist.emailExists;
